<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="true"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>

<div class="content-page">
    <div class="content p-1 crumbs">
        <div class="content text-dark">
            <div class="d-flex align-items-center">
                <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
                    <ol class="breadcrumb text-capitalize text-dark h5">
                        <li class="breadcrumb-item"><a [routerLink]="['/reports']" class="text-secondary">Reports</a></li>
                        <li class="breadcrumb-item text-secondary" aria-current="page">Cash Flow Report</li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    
    @if (security.permitted('reports', 'cash flow', 'view')) {
        <aside>            
            <form [formGroup]="form">
                <div class="form-group">
                    <select class="form-control form-control-sm" name="lot" id="lot-filter" formControlName="lotId">
                        <option value="0">All Lots</option>
                        @for (lot of lots; track lot.id) {
                            <option value="{{lot.id}}">{{lot.contact.name}}</option>
                        }
                    </select>
                </div>
                <div class="form-group">
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <span class="input-group-text">from</span>
                        </div>
                        <input type="date" select class="form-control form-control-sm" name="from" id="from-filter" formControlName="from" />
                    </div>
                </div>
                <div class="form-group">
                    
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <span class="input-group-text">to</span>
                        </div>
                        <input type="date" select class="form-control form-control-sm" name="to" id="to-filter" formControlName="to" />
                    </div>
                </div>
            </form>
        </aside>

        <main>
            @if (summary) {
                <h3>Cash Flow Report</h3>
                <h4>{{dateSpan}}</h4>
                <h4>{{summary.corporation}}</h4>
                <h5 class="text-muted">{{summary.address}} {{summary.cityStateZip}}</h5>

                <ul class="list-group justify-content-center flexed">
                    <li class="list-group-item">
                        <div>
                            <p class="text-primary">Scheduled Payments Received on In-House Finance Deals</p>
                            <p class="subtitle">Late Fees</p>
                        </div>
                        <div>
                            <p>{{summary.bhph + summary.lates | currency}}</p>
                            <p class="subtitle">{{summary.lates | currency}}</p>
                        </div>
                    </li>
                    <li class="list-group-item"><span class="text-primary">Deposit Payments Received on In-House Finance Deals</span> <span>{{summary.deposits | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Down Payments Received on In-House Finance Deals</span> <span>{{summary.downs | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Deposit Payments Received on Outside Finance Deals</span> <span>{{summary.depositsOutside | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Down Payments Received on Outside Finance Deals</span> <span>{{summary.downsOutside | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Lienholder Funding Received on Outside Finance Deals</span> <span>{{summary.outside | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Cash Sales Less Associated Net Trade-Ins</span> <span>{{summary.cash | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Wholesale Payments Received</span> <span>{{summary.wholesale | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Payments Received from CPI Charges</span> <span>{{summary.cpi | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Payments Received from After-Sale Charges</span> <span>{{summary.afterSale | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Payments Received from Bounce Charges</span> <span>{{summary.bounce | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Payments Received from Other Charges</span> <span>{{0 | currency}}</span></li>
                    <li class="list-group-item total"><span class="text-primary">Total Cash Flow</span> <span class="text-primary">{{totalFlow(summary) | currency}}</span></li>
                    @if (summary.scheduled > 0) {
                        <li class="list-group-item">
                            <div>
                                <p>Ideally cash flow covers at least 105% of scheduled payments for any given time period.</p>
                                <p class="subtitle">Scheduled payments for the same time period total {{summary.scheduled | currency}}</p>
                            </div>
                            <div><span class="badge badge-pill badge-{{colorize(summary)}}">{{totalFlow(summary) / summary.scheduled | percent: '1.2-2'}}</span></div>
                        </li>
                    }
                </ul>
            }

            @if (summary && saleSummary) {
                <ul class="list-group justify-content-center flexed">
                    <li class="list-group-item title">Total Sales</li>
                    <li class="list-group-item"><span>Total In-House Financed Sales</span> <span>{{saleSummary.bhph | currency}}</span></li>
                    <li class="list-group-item"><span>Total Cash Sales</span> <span>{{saleSummary.cash | currency}}</span></li>
                    <li class="list-group-item"><span>Total Outsdide Financed Sales</span> <span>{{saleSummary.outside | currency}}</span></li>
                    <li class="list-group-item"><span>Total Wholesale Sales</span> <span>{{saleSummary.wholesale | currency}}</span></li>
                    <li class="list-group-item total"><span>Total Sales</span> <span>{{saleSummary.total | currency}}</span></li>
                </ul>
            }

            @if (summary && saleSummary) {
                <h5 class="list-group-item title">Receivables Change</h5>
                <ol class="justify-content-center">
                    <li><span>1. Receivables change from sales</span> <span>{{saleSummary.payments | currency}}</span></li>
                    <li><span>2. Receivables change from payments</span> <span>{{summary.bhph + summary.lates | currency}}</span></li>
                    <li class="total"><span>Receivables total change (1-2)</span> <span>{{saleSummary.payments - (summary.bhph + summary.lates) | currency}}</span></li>
                </ol>

                <hr />
            }

            @for (item of grouped | keyvalue; track item.key; let idx = $index) {
                @if (idx > 0) {
                    <hr />
                }

                @if (item.value['summary']) {
                    <h4>{{item.value['summary'].name}}</h4>
                    <h5 class="text-muted">{{item.value['summary'].address}} {{item.value['summary'].cityStateZip}}</h5>

                    <ul class="list-group justify-content-center flexed">
                        <li class="list-group-item">
                            <div>
                                <p class="text-primary">Scheduled Payments Received on In-House Finance Deals</p>
                                <p class="subtitle">Late Fees</p>
                            </div>
                            <div>
                                <p>{{item.value['summary'].bhph + item.value['summary'].lates | currency}}</p>
                                <p class="subtitle">{{item.value['summary'].lates | currency}}</p>
                            </div>
                        </li>
                        <li class="list-group-item"><span class="text-primary">Deposit Payments Received on In-House Finance Deals</span> <span>{{item.value['summary'].deposits | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Down Payments Received on In-House Finance Deals</span> <span>{{item.value['summary'].downs | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Deposit Payments Received on Outside Finance Deals</span> <span>{{item.value['summary'].depositsOutside | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Down Payments Received on Outside Finance Deals</span> <span>{{item.value['summary'].downsOutside | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Lienholder Funding Received on Outside Finance Deals</span> <span>{{item.value['summary'].outside | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Cash Sales Less Associated Net Trade-Ins</span> <span>{{item.value['summary'].cash | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Wholesale Payments Received</span> <span>{{item.value['summary'].wholesale | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Payments Received from CPI Charges</span> <span>{{item.value['summary'].cpi | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Payments Received from After-Sale Charges</span> <span>{{item.value['summary'].afterSale | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Payments Received from Bounce Charges</span> <span>{{item.value['summary'].bounce | currency}}</span></li>
                        <li class="list-group-item"><span class="text-primary">Payments Received from Other Charges</span> <span>{{0 | currency}}</span></li>
                        <li class="list-group-item total"><span class="text-primary">Total Cash Flow</span> <span class="text-primary">{{totalFlow(item.value['summary']) | currency}}</span></li>
                        @if (item.value['summary'].scheduled > 0) {
                            <li class="list-group-item">
                                <div>
                                    <p>Ideally cash flow covers at least 105% of scheduled payments for any given time period.</p>
                                    <p class="subtitle">Scheduled payments for the same time period total {{item.value['summary'].scheduled | currency}}</p>
                                </div>
                                <div><span class="badge badge-pill badge-{{colorize(item.value['summary'])}}">{{totalFlow(item.value['summary']) / item.value['summary'].scheduled | percent: '1.2-2'}}</span></div>
                            </li>
                        }
                    </ul>
                }

                @if (item.value['saleSummary']) {
                    <ul class="list-group justify-content-center flexed">
                        <li class="list-group-item title">Total Sales</li>
                        <li class="list-group-item"><span>Total In-House Financed Sales</span> <span>{{item.value['saleSummary'].bhph | currency}}</span></li>
                        <li class="list-group-item"><span>Total Cash Sales</span> <span>{{item.value['saleSummary'].cash | currency}}</span></li>
                        <li class="list-group-item"><span>Total Outsdide Financed Sales</span> <span>{{item.value['saleSummary'].outside | currency}}</span></li>
                        <li class="list-group-item"><span>Total Wholesale Sales</span> <span>{{item.value['saleSummary'].wholesale | currency}}</span></li>
                        <li class="list-group-item total"><span>Total Sales</span> <span>{{item.value['saleSummary'].total | currency}}</span></li>
                    </ul>
                }

                @if (item.value['summary'] && item.value['saleSummary']) {
                    <h5 class="list-group-item title">Receivables Change</h5>
                    <ol class="justify-content-center">
                        <li><span>1. Receivables change from sales</span> <span>{{item.value['saleSummary'].payments | currency}}</span></li>
                        <li><span>2. Receivables change from payments</span> <span>{{item.value['summary'].bhph + item.value['summary'].lates | currency}}</span></li>
                        <li class="total"><span>Receivables total change (1-2)</span> <span>{{item.value['saleSummary'].payments - (item.value['summary'].bhph + item.value['summary'].lates) | currency}}</span></li>
                    </ol>
                }

                @if (item.value['saleCount'] > 0) {
                    <h4 class="text-center section-header">Total Sales Breakdown by Category</h4>

                    <ul class="list-group list-group-horizontal justify-content-center flexed">
                        <li class="list-group-item">
                            <span class="text-primary">Count</span>
                            <span>{{item.value['saleCount'] | number: '1.0-0'}}</span>
                            <span class="text-primary">Total</span>
                            <span>{{item.value['saleTotal'] | currency}}</span>
                        </li>
                    </ul>
                }

                @if (item.value['cash'] && (item.value['cash'].length > 0)) {
                    <table class="table table-sm details">
                        <thead>
                            <tr><th colspan="9" scope="col"><h4 class="text-center">Cash Sales</h4></th></tr>
                            <tr>
                                <th scope="col">Customer</th>
                                <th scope="col">Stock</th>
                                <th scope="col">Vehicle</th>
                                <th scope="col">Paid</th>
                                <th scope="col" class="text-center">Category</th>
                                <th scope="col" class="text-center">Method</th>
                                <th scope="col">By</th>
                                <th scope="col" class="text-center">Method</th>
                                <th scope="col" class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (sale of item.value['cash']; track sale.id) {
                                <tr>
                                    <td>{{sale.buyer}}</td>
                                    <td>{{sale.stock}}</td>
                                    <td>{{sale.yearMakeModel}}</td>
                                    <td>{{sale.sold | date: 'shortDate'}}</td>
                                    <td class="text-center">{{sale.category}}</td>
                                    <td class="text-center">{{sale.method}}</td>
                                    <td>{{sale.receiver}}</td>
                                    <td class="text-center">{{sale.number}}</td>
                                    <td class="text-right">{{sale.amount | currency}}</td>
                                </tr>
                            }
                            <tr class="total">
                                <td>Count: {{item.value['cash'].length | number: '1.0-0'}}</td>
                                <td colspan="8" class="text-right">{{item.value['cashTotal'] | currency}}</td>
                            </tr>
                        </tbody>
                    </table>
                }

                @if (item.value['wholesale'] && (item.value['wholesale'].length > 0)) {
                    <table class="table table-sm details">
                        <thead>
                            <tr><th colspan="9" scope="col"><h4 class="text-center">Wholesale Sales</h4></th></tr>
                            <tr>
                                <th scope="col">Customer</th>
                                <th scope="col">Stock</th>
                                <th scope="col">Vehicle</th>
                                <th scope="col">Paid</th>
                                <th scope="col" class="text-center">Category</th>
                                <th scope="col" class="text-center">Method</th>
                                <th scope="col">By</th>
                                <th scope="col" class="text-center">#</th>
                                <th scope="col" class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (sale of item.value['wholesale']; track sale.id) {
                                <tr>
                                    <td>{{sale.buyer}}</td>
                                    <td>{{sale.stock}}</td>
                                    <td>{{sale.yearMakeModel}}</td>
                                    <td>{{sale.sold | date: 'shortDate'}}</td>
                                    <td class="text-center">{{sale.category}}</td>
                                    <td class="text-center">{{sale.method}}</td>
                                    <td>{{sale.receiver}}</td>
                                    <td class="text-center">{{sale.number}}</td>
                                    <td class="text-right">{{sale.amount | currency}}</td>
                                </tr>
                            }
                            <tr class="total">
                                <td>Count: {{item.value['wholesale'].length | number: '1.0-0'}}</td>
                                <td colspan="8" class="text-right">{{item.value['wholesaleTotal'] | currency}}</td>
                            </tr>
                        </tbody>
                    </table>
                }

                @if (item.value['outside'] && (item.value['outside'].length > 0)) {
                    <table class="table table-sm details">
                        <thead>
                            <tr><th colspan="9" scope="col"><h4 class="text-center">Outside Financed Sales</h4></th></tr>
                            <tr>
                                <th scope="col">Customer</th>
                                <th scope="col">Stock</th>
                                <th scope="col">Vehicle</th>
                                <th scope="col">Paid</th>
                                <th scope="col" class="text-center">Category</th>
                                <th scope="col" class="text-center">Method</th>
                                <th scope="col">By</th>
                                <th scope="col" class="text-center">#</th>
                                <th scope="col" class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (sale of item.value['outside']; track sale.id) {
                                <tr>
                                    <td>{{sale.buyer}}</td>
                                    <td>{{sale.stock}}</td>
                                    <td>{{sale.yearMakeModel}}</td>
                                    <td>{{sale.sold | date: 'shortDate'}}</td>
                                    <td class="text-center">{{sale.category}}</td>
                                    <td class="text-center">{{sale.method}}</td>
                                    <td>{{sale.receiver}}</td>
                                    <td class="text-center">{{sale.number}}</td>
                                    <td class="text-right">{{sale.amount | currency}}</td>
                                </tr>
                            }
                            <tr class="total">
                                <td>Count: {{item.value['outside'].length | number: '1.0-0'}}</td>
                                <td colspan="8" class="text-right">{{item.value['outsideTotal'] | currency}}</td>
                            </tr>
                        </tbody>
                    </table>
                }

                @if (item.value['bhphDeferred'] && (item.value['bhphDeferred'].length > 0)) {
                    <table class="table table-sm details">
                        <thead>
                            <tr><th colspan="9" scope="col"><h4 class="text-center">Buy Here - Pay Here Sales (DEFERRED)</h4></th></tr>
                            <tr>
                                <th scope="col">Customer</th>
                                <th scope="col">Stock</th>
                                <th scope="col">Vehicle</th>
                                <th scope="col">Paid</th>
                                <th scope="col" class="text-center">Category</th>
                                <th scope="col" class="text-center">Method</th>
                                <th scope="col">By</th>
                                <th scope="col" class="text-center">#</th>
                                <th scope="col" class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (sale of item.value['bhphDeferred']; track sale.id) {
                                <tr>
                                    <td>{{sale.buyer}}</td>
                                    <td>{{sale.stock}}</td>
                                    <td>{{sale.yearMakeModel}}</td>
                                    <td>{{sale.sold | date: 'shortDate'}}</td>
                                    <td class="text-center">{{sale.category}}</td>
                                    <td class="text-center">{{sale.method}}</td>
                                    <td>{{sale.receiver}}</td>
                                    <td class="text-center">{{sale.number}}</td>
                                    <td class="text-right">{{sale.amount | currency}}</td>
                                </tr>
                            }
                            <tr class="total">
                                <td>Count: {{item.value['bhphDeferred'].length | number: '1.0-0'}}</td>
                                <td colspan="8" class="text-right">{{item.value['bhphDeferredTotal'] | currency}}</td>
                            </tr>
                        </tbody>
                    </table>
                }

                @if (item.value['bhphPaid'] && (item.value['bhphPaid'].length > 0)) {
                    <table class="table table-sm details">
                        <thead>
                            <tr><th colspan="9" scope="col"><h4 class="text-center">Buy Here - Pay Here Sales (PAID)</h4></th></tr>
                            <tr>
                                <th scope="col">Customer</th>
                                <th scope="col">Stock</th>
                                <th scope="col">Vehicle</th>
                                <th scope="col">Paid</th>
                                <th scope="col" class="text-center">Category</th>
                                <th scope="col" class="text-center">Method</th>
                                <th scope="col">By</th>
                                <th scope="col" class="text-center">#</th>
                                <th scope="col" class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (sale of item.value['bhphPaid']; track sale.id) {
                                <tr>
                                    <td>{{sale.buyer}}</td>
                                    <td>{{sale.stock}}</td>
                                    <td>{{sale.yearMakeModel}}</td>
                                    <td>{{sale.sold | date: 'shortDate'}}</td>
                                    <td class="text-center">{{sale.category}}</td>
                                    <td class="text-center">{{sale.method}}</td>
                                    <td>{{sale.receiver}}</td>
                                    <td class="text-center">{{sale.number}}</td>
                                    <td class="text-right">{{sale.amount | currency}}</td>
                                </tr>
                            }
                            <tr class="total">
                                <td>Count: {{item.value['bhphPaid'].length | number: '1.0-0'}}</td>
                                <td colspan="8" class="text-right">{{item.value['bhphPaidTotal'] | currency}}</td>
                            </tr>
                        </tbody>
                    </table>
                }
            }

        </main>
    }
</div>
